import React from 'react';

export const NavigationItemLink = ({ href, className, children }: React.AnchorHTMLAttributes<HTMLAnchorElement>) => (
  <a href={href} className={className}>
    {children}
  </a>
);
